import React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import urls, { relativeUrl } from '@/constants/urls';
import Events from '@/roles/hooks/events';

const AdminRoleMenu = ({ allowNewRoles, allowRoles }) => {
  const newRole = Events.useShowRole(null, { code: null });
  return (
    <>
      {allowNewRoles && (
        <Dropdown.Item as="a" onClick={newRole} selected={false}>
          <Icon name="plus" className="primary" />
          <FormattedMessage id="role.header.menu.new" />
        </Dropdown.Item>
      )}
      {allowRoles && (
        <Dropdown.Item as="a" href={`#${relativeUrl(urls.ROLES)}`} selected={false}>
          <Icon name="drivers license" className="primary" />
          <FormattedMessage id="admin.header.menu.roles" />
        </Dropdown.Item>
      )}
    </>
  );
};

export default AdminRoleMenu;
